export default __webpack_public_path__ + "static/media/saunatimeFacebook-1200x630.4c4d4330.jpg";